import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import type {Nullish} from 'shared/web';

import {smtpCredentialsTestReason} from '../constants/smtpCredentialsTestReason';
import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import {smtpCredentialsTestType} from '../constants/smtpCredentialsTestType';

export function getSmtpTestTypeHint(type: string, status: string, reason: string | Nullish) {
  if (status === smtpCredentialsTestStatus.skip) {
    return null;
  }

  return match(reason)
    .with(smtpCredentialsTestReason.hostNotAllowed, () =>
      i18n.t('entity.emailService.labels.testHintHostNotAllowed')
    )
    .with(smtpCredentialsTestReason.hostUnresolvable, () =>
      i18n.t('entity.emailService.labels.testHintHostUnresolvable')
    )
    .with(smtpCredentialsTestReason.connectionTimedOut, () =>
      i18n.t('entity.emailService.labels.testHintConnectionTimedOut')
    )
    .with(smtpCredentialsTestReason.connectionFailed, () =>
      i18n.t('entity.emailService.labels.testHintConnection')
    )
    .with(smtpCredentialsTestReason.startTlsFailed, () =>
      i18n.t('entity.emailService.labels.testHintTls')
    )
    .with(smtpCredentialsTestReason.tlsUnavailable, () =>
      i18n.t('entity.emailService.labels.testHintTlsUnencrypted')
    )
    .with(smtpCredentialsTestReason.authenticationFailed, () =>
      i18n.t('entity.emailService.labels.testHintAuthentication')
    )
    .with(smtpCredentialsTestReason.unexpectedError, () =>
      i18n.t('entity.emailService.labels.testHintUnexpectedError')
    )
    .otherwise(() => getTypeHint(type, status));
}

function getTypeHint(type: string, status: string) {
  return match([type, status])
    .with([smtpCredentialsTestType.connection, smtpCredentialsTestStatus.failed], () =>
      i18n.t('entity.emailService.labels.testHintConnection')
    )
    .with([smtpCredentialsTestType.tls, smtpCredentialsTestStatus.failed], () =>
      i18n.t('entity.emailService.labels.testHintTls')
    )
    .with([smtpCredentialsTestType.tls, smtpCredentialsTestStatus.warning], () =>
      i18n.t('entity.emailService.labels.testHintTlsUnencrypted')
    )
    .with([smtpCredentialsTestType.authentication, smtpCredentialsTestStatus.failed], () =>
      i18n.t('entity.emailService.labels.testHintAuthentication')
    )
    .otherwise(() => null);
}
